// /survey is the universal fallback for clients: isFullserve, isSelfserve,
// canAepSurvey and the store's onSurveyDone all redirect there. But the page
// behind it is the AGENT client-detail view, and it dereferences
// surveyRoutesMap["demographics"].path (plus providers/drugs/pharmacies)
// unguarded. A client's nav is derived from the checkup wizard, so those keys
// are /checkup/* and the lookups are undefined — every one of those redirects
// dropped the client on "Cannot read properties of undefined (reading 'path')".
//
// Clients belong in the checkup wizard now, so send them there. Agents keep the
// page: their nav really does carry /survey/{uid}/* and those keys resolve.
export default function ({ store, redirect, route }) {
    if (store.getters.canAgent) { return }
    return redirect('/checkup/welcome', { ...route.query })
}
